import React, { useState, useEffect } from 'react';
// import styled from 'styled-components';
// import MainHeader from '../components/MainHeader';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import {
  Page,
  Container,
  FlexRow,
  PageTitle,
  MTDStat,
  Card,
  ChartCardGrid,
  StatLabel,
  SubChartLabel,
  TableCard,
  Table,
  Badge,
  FilterInputsRow,
  FilterInput,
  Label,
  FilterSelect,
  ApplyBtn,
  SectionTitle,
  FilterInputContainer,
  TinyValue,
} from '../styles/dashboard.styles';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000/api/v1';

function formatCurrency(value) {
  if (value == null) return '-';
  return `₹${Number(value).toLocaleString()}`;
}

export default function Dashboard() {
  // State for all dashboard data
  const userData = {
    user : JSON.parse(localStorage.getItem('user')),
    token : localStorage.getItem('access_token')
  }

  const isAdmin = userData.user.roles.role_name == "SUPER_ADMIN"
  const [salesSummary, setSalesSummary] = useState({
    petpooja_sale: 0,
    variance: 0,
    expenses: 0,
    pending_bills: 0,
    month_to_date_sales: 0,
    wastage_report: null,
  });
  const navigate = useNavigate()
  const [duesExpenseData,setDuesExpenseData] = useState({})
  const [salesGrowthData, setSalesGrowthData] = useState([]);
  const [onlineGrowthZomato, setOnlineGrowthZomato] = useState([]);
  const [onlineGrowthSwiggy, setOnlineGrowthSwiggy] = useState([]);
  const [cashFlowEntries, setCashFlowEntries] = useState([]);
  const [stores, setStores] = useState([]);

const hostname = window.location.hostname;
  const isInventoryDomain = hostname === 'inventory.fescafe.in' || hostname === 'localhost';
  const isRecordsDomain = hostname === 'records.fescafe.in' ;
useEffect(() => {
    if(!isAdmin)
      navigate(isRecordsDomain ?'/cashflow' : '/inventory/entries')
  }, []);
const [filters, setFilters] = useState({
  fromDate: '',
  toDate: '',
  location: ''  // Array of selected store IDs for multi-select
});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch dashboard data when component mounts or filters change
  useEffect(() => {
    if(!isAdmin)
            navigate('/');
    async function fetchDashboardData() {
      setLoading(true);
      setError('');
      try {
        // Build query string params
        const params = new URLSearchParams();
        console.log("Location filter value : ",filters.location)
        if (filters.fromDate) params.append('fromDate', filters.fromDate);
                if (filters.toDate) params.append('toDate', filters.toDate);
            if(filters.location) params.append('location',filters.location)
        // Omitting location filter because API aggregates all locations
        const token = localStorage.getItem('access_token');

        const response = await fetch(`${API_URL}/dashboard?${params.toString()}`, {
  headers: {
    'Authorization': `Bearer ${token}`
  }
});
        if (!response.ok) throw new Error(`Error fetching dashboard data: ${response.statusText}`);
        const data = await response.json();
        const expensesAndDues = data.expensesAndDues
        setDuesExpenseData(expensesAndDues)
        console.log("Ashmin testing for expenses and dues data :",expensesAndDues)
        // Set stores for location filter dropdown
        setStores(data.stores || []);

        // Map summary data
        const summary = data.sales_summary || {};
        setSalesSummary({
          petpooja_sale: summary.petpooja_sale || 0,
          variance: summary.variance || 0,
          expenses: summary.expenses || 0,
          pending_bills: summary.pending_bills || 0,
          month_to_date_sales: summary.month_to_date_sales || 0,
          wastage_report: summary.wastage_report || null,
        });

        // Map charts data
        const salesGrowthSorted = (data.charts?.sales_growth || [])
  .map(({ date, sales }) => ({ date, sales: Number(sales) }))
  .sort((a, b) => new Date(a.date) - new Date(b.date));
setSalesGrowthData(salesGrowthSorted);

        // Online platforms assumed to be 'Zomato' and 'Swiggy'
        const onlineGrowthData = data.charts?.online_growth || {};
        const zomatoSorted = (onlineGrowthData.Zomato || [])
  .map(({ date, amount }) => ({ date, sales: Number(amount) }))
  .sort((a, b) => new Date(a.date) - new Date(b.date));
setOnlineGrowthZomato(zomatoSorted);

        const swiggySorted = (onlineGrowthData.Swiggy || [])
  .map(({ date, amount }) => ({ date, sales: Number(amount) }))
  .sort((a, b) => new Date(a.date) - new Date(b.date));
setOnlineGrowthSwiggy(swiggySorted);

        // Map cash flow entries
        setCashFlowEntries(
          (data.entries || []).map((entry) => ({
            date: entry.date,
            location: entry.location,
            openingCash: entry.opening_cash ? Number(entry.opening_cash).toLocaleString() : '-',
            petPoojaSale: entry.petpooja_sale ? Number(entry.petpooja_sale).toLocaleString() : '-',
            variance: entry.variance ? Number(entry.variance).toLocaleString() : '0',
            expenses: entry.expenses ? Number(entry.expenses).toLocaleString() : '0',
            bankDeposits: entry.bank_deposits ? Number(entry.bank_deposits).toLocaleString() : '-',
            pending: entry.pending_bills || '-',
            duesReceived : entry.dues_received || '-'
          }))
        );
      } catch (err) {
        setError(err.message || 'Failed to fetch dashboard data');
      } finally {
        setLoading(false);
      }
    }

    fetchDashboardData();
  }, [filters]);

  // Handle input change for filters
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Apply filters button handler (currently does nothing special since useEffect triggers)
  const handleResetFilters = () => {
    // No extra implementation needed; useEffect already responds to filters change
    setFilters({
  fromDate: '',
  toDate: '',
  location: ''  // Array of selected store IDs for multi-select
})
  };

  return (
    <>
      {loading && <Loader />}
      <Page>
        <Container>
          <FlexRow>
            <PageTitle>Dashboard</PageTitle>
            <MTDStat>
              <span style={{ fontSize: '1rem', color: '#8796b1', fontWeight: 400 }}>Month to Date Sales</span>
              <div style={{ fontSize: '1.39rem', fontWeight: 700, color: '#20294d', marginTop: 3 }}>
                {formatCurrency(salesSummary.month_to_date_sales)}
              </div>
            </MTDStat>
          </FlexRow>

          <Card>
            <StatLabel>Admin Filters</StatLabel>
            <FilterInputsRow>
              <FilterInputContainer>
                <Label htmlFor="dateFilter">From</Label>
                                  <FilterInput
  type="date"
  id="fromDateFilter"
  name="fromDate"
  value={filters.fromDate}
  onChange={handleFilterChange}
/>


              </FilterInputContainer>
              <FilterInputContainer>
                <Label htmlFor="dateFilter">To</Label>
                                  <FilterInput
  type="date"
  id="toDateFilter"
  name="toDate"
  value={filters.toDate}
  onChange={handleFilterChange}
/>


              </FilterInputContainer>
              <FilterInputContainer>
                <Label htmlFor="locationFilter">Location</Label>
                <FilterSelect id="locationFilter" name="location" value={filters.location} onChange={handleFilterChange} >
                  <option value="all">All locations</option>
                  {stores.map((store) => (
                    <option key={store.id} value={store.id}>
                      {store.friendly_name}
                    </option>
                  ))}
                </FilterSelect>
              </FilterInputContainer>
              <ApplyBtn onClick={handleResetFilters} disabled={loading}>
                {loading ? 'Loading...' : 'Reset Filters'}
              </ApplyBtn>
            </FilterInputsRow>
          </Card>

          {error && (
            <Card style={{ backgroundColor: '#fddede', color: '#d24949', margin: '16px 0', padding: '16px' }}>
              Error: {error}
            </Card>
          )}

          <ChartCardGrid>
            <Card>
              <Card style={{ minWidth: 0, margin: 0, boxShadow: 'none', background: 'none', padding: 0 }}>
                <SectionTitle>PetPooja Sale</SectionTitle>
                <div style={{ fontSize: '1.10rem', fontWeight: 600, marginTop: 8 }}>{formatCurrency(salesSummary.petpooja_sale)}</div>
                <div style={{ color: '#aaa', fontSize: '0.98em', margin: '7px 0 0 1px' }}>Today • All locations</div>
              </Card>
            </Card>

            <Card>
              <Card style={{ minWidth: 0, margin: 0, boxShadow: 'none', background: 'none', padding: 0 }}>
                <SectionTitle>Variance</SectionTitle>
                <div
                  style={{
                    fontSize: '1.10rem',
                    fontWeight: 600,
                    marginTop: 8,
                    color: +salesSummary.variance > 0 ? '#19b157' : '#d24949',
                  }}
                >
                  {formatCurrency(salesSummary.variance)}
                </div>
                <TinyValue>Difference vs calculated sale</TinyValue>
              </Card>
            </Card>

            <Card>
              <Card style={{ minWidth: 0, margin: 0, boxShadow: 'none', background: 'none', padding: 0 }}>
                <SectionTitle>Expenses and Dues</SectionTitle>
                <div style={{ color: '#000000ff', fontSize: '0.99em', marginTop: 7 }}>
                  Pending Dues : {formatCurrency(duesExpenseData.pending_dues || 0)}
                </div>
                <div style={{ color: '#000000ff', fontSize: '0.99em', marginTop: 7 }}>
                  Dues Received : {formatCurrency(duesExpenseData.dues_received || 0)}
                </div>
              </Card>
            </Card>
          </ChartCardGrid>

          <ChartCardGrid>
            <Card>
              <StatLabel>Sales Growth (MTD)</StatLabel>
              <ResponsiveContainer width="100%" height={300} style={{ marginBottom: '30px' }}>
                <LineChart data={salesGrowthData} margin={{ top: 20, right: 12, bottom: 2, left: 0 }}>
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis
                    dataKey="date"
                    tick={{ fontSize: 12, fill: '#6b7280' }}
                    label={{
                      value: 'Date',
                      position: 'insideBottom',
                      offset: -20,
                      style: { fontSize: 12, fill: '#374151', fontWeight: 'bold' },
                    }}
                  />
                  <YAxis
                    tick={{ fontSize: 12, fill: '#6b7280' }}
                    label={{
                      value: 'Sales (₹)',
                      angle: -90,
                      position: 'insideLeft',
                      style: {
                        textAnchor: 'middle',
                        fontSize: 15,
                        fill: '#374151',
                        fontWeight: 'bold',
                      },
                    }}
                  />
                  <Tooltip formatter={(v) => `₹${v.toLocaleString()}`} />
                  <Line type="monotone" dataKey="sales" stroke="#EB8477" dot activeDot={{ r: 5 }} strokeWidth={2.8} />
                </LineChart>
              </ResponsiveContainer>
            </Card>

            <Card>
              <StatLabel>Online Growth</StatLabel>
              <SubChartLabel style={{ marginTop: 16, marginBottom: 16 }}>Zomato</SubChartLabel>
              <ResponsiveContainer width="100%" height={120}>
                <LineChart data={onlineGrowthZomato} margin={{ top: 10, right: 10, bottom: 4, left: 0 }}>
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis
                    dataKey="date"
                    tick={{ fontSize: 10, fill: '#6b7280' }}
                    label={{
                      value: 'Date',
                      position: 'insideBottom',
                      offset: -20,
                      style: { fontSize: 11, fill: '#374151', fontWeight: 'bold' },
                    }}
                  />
                  <YAxis
                    tick={{ fontSize: 10, fill: '#6b7280' }}
                    label={{
                      value: 'Sales (₹)',
                      angle: -90,
                      position: 'insideLeft',
                      style: {
                        textAnchor: 'middle',
                        fontSize: 11,
                        fill: '#374151',
                        fontWeight: 'bold',
                      },
                    }}
                  />
                  <Tooltip formatter={(v) => `₹${v.toLocaleString()}`} />
                  <Line type="monotone" dataKey="sales" stroke="#27cbc0" dot activeDot={{ r: 5 }} strokeWidth={2.5} />
                </LineChart>
              </ResponsiveContainer>

              <SubChartLabel style={{ marginTop: 16, marginBottom: 16 }}>Swiggy</SubChartLabel>
              <ResponsiveContainer width="100%" height={120}>
                <LineChart data={onlineGrowthSwiggy} margin={{ top: 10, right: 10, bottom: 4, left: 0 }}>
                  <CartesianGrid stroke="#f5f5f5" />
                  <XAxis
                    dataKey="date"
                    tick={{ fontSize: 10, fill: '#6b7280' }}
                    label={{
                      value: 'Date',
                      position: 'insideBottom',
                      offset: -20,
                      style: { fontSize: 11, fill: '#374151', fontWeight: 'bold' },
                    }}
                  />
                  <YAxis
                    tick={{ fontSize: 10, fill: '#6b7280' }}
                    label={{
                      value: 'Sales (₹)',
                      angle: -90,
                      position: 'insideLeft',
                      style: {
                        textAnchor: 'middle',
                        fontSize: 11,
                        fill: '#374151',
                        fontWeight: 'bold',
                      },
                    }}
                  />
                  <Tooltip formatter={(v) => `₹${v.toLocaleString()}`} />
                  <Line type="monotone" dataKey="sales" stroke="#3E6DB0" dot activeDot={{ r: 5 }} strokeWidth={2.5} />
                </LineChart>
              </ResponsiveContainer>
            </Card>
          </ChartCardGrid>

          <TableCard>
            <StatLabel>Cash Flow Entries ({cashFlowEntries.length})</StatLabel>
            <Table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Location</th>
                  <th>Opening Cash</th>
                  <th>PetPooja Sale</th>
                  <th>Variance</th>
                  <th>Expenses</th>
                  <th>Bank Deposits</th>
                  <th>Pending Bills</th>
                  <th>Dues Received</th>

                </tr>
              </thead>
              <tbody>
                {cashFlowEntries.map((entry, idx) => (
                  <tr key={idx}>
                    <td>{entry.date}</td>
                    <td>
                      <Badge>{entry.location}</Badge>
                    </td>
                    <td>{entry.openingCash}</td>
                    <td>{entry.petPoojaSale}</td>
                    <td
                      style={{
                        color: +entry.variance > 0 ? '#19b157' : '#d24949',
                        fontWeight: 700,
                      }}
                    >
                      {entry.variance}
                    </td>
                    <td>{entry.expenses}</td>
                    <td>{entry.bankDeposits}</td>
                    <td>{entry.pending}</td>
                    <td>{entry.duesReceived}</td>

                  </tr>
                ))}
              </tbody>
            </Table>
          </TableCard>
        </Container>
      </Page>
    </>
  );
}
